import React from 'react';
import PropTypes from 'prop-types';
import PageHeaderNavMenuComponent from './PageHeaderNavMenuComponent';
import { getBEMClasses } from '../../helpers/cssClassesHelper';
import APIcon from 'apex-web/lib/components/common/APIcon';

import './PageHeaderNavComponent.css';

const PageHeaderNavClasses = getBEMClasses('page-header-nav');

export default class PageHeaderNavComponent extends React.Component {
  state = {
    isOpen: false
  };

  handleClick = () => {
    if (!this.state.isOpen) {
      document.addEventListener('click', this.handleOutsideClick, false);
    } else {
      document.removeEventListener('click', this.handleOutsideClick, false);
    }

    this.setState(prevState => ({
      isOpen: !prevState.isOpen
    }));
  };

  handleOutsideClick = e => {
    if (this.node.contains(e.target)) {
      return;
    }
    this.handleClick();
  };

  componentWillUnmount() {
    document.removeEventListener('click', this.handleOutsideClick, false);
  }

  render() {
    const { sidebar, navItems, onSidebarItemClick } = this.props;
    const onNavItemClick = sidebar
      ? onSidebarItemClick || (() => {})
      : this.handleClick;
    return (
      <div
        className={PageHeaderNavClasses(
          'container',
          sidebar ? 'sidebar' : this.state.isOpen ? '' : 'closed'
        )}
        ref={node => {
          this.node = node;
        }}>
        {!sidebar && (
          <div
            className={PageHeaderNavClasses(
              'menu-toggle',
              this.state.isOpen ? 'active' : ''
            )}
            onClick={this.handleClick}>
            <APIcon
              name="menu-toggle"
              customClass={PageHeaderNavClasses('icon')}
            />
          </div>
        )}
        <PageHeaderNavMenuComponent
          customClass={PageHeaderNavClasses}
          handleNavItemClick={onNavItemClick}
          navItems={navItems}
          sidebar={sidebar}
        />
      </div>
    );
  }
}

PageHeaderNavComponent.propTypes = {
  navItems: PropTypes.array,
  sidebar: PropTypes.bool,
  onSidebarItemClick: PropTypes.func
};
